import Api from "./tumourApi";
import GlobalApi from "./globalApi";
import { combineFilters } from "./modulesCommon";

const KAPLAN_MEIER_ANALYSIS = "KAPLAN_MEIER_ANALYSIS";
const KAPLAN_MEIER_ANALYSIS_EXCEL_EXPORT = "KAPLAN_MEIER_ANALYSIS_EXCEL_EXPORT";
const KM_TAB_ACTIVE = "KM_TAB_ACTIVE";

const kaplanMeierModule = {
    namespaced: true,
    state: () => ({
        kaplanMeierParameter: {
            duration: null,
            terminationCriteria: null,
        },
        kaplanMeierResult: {},
        kaplanMeierExcelExport: {},
        kmTabActive: false,
    }),
    actions: {
        getExcelExport({ rootState }, context) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);
            return GlobalApi.GetExcelExport(context, filters, rootState);
        },
        readKaplanMeierEstimates({ commit, rootState }, context) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);

            return Api.GetKaplanMeierEstimates(context.context, context.kaplanMeierParameter, filters, rootState).then(
                function (result) {
                    commit(KAPLAN_MEIER_ANALYSIS, result.data.table);
                },
            );
        },
        readKaplanMeierEstimatesAsExcelFile({ rootState }, context) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);

            return Api.GetKaplanMeierEstimatesAsExcelExport(
                context.context,
                context.kaplanMeierParameter,
                filters,
                rootState,
            );
        },
        setKmTabActive({ commit }, isActive) {
            commit(KM_TAB_ACTIVE, isActive);
        },
    },
    mutations: {
        [KAPLAN_MEIER_ANALYSIS](state, obj) {
            state.kaplanMeierResult = obj;
        },
        [KAPLAN_MEIER_ANALYSIS_EXCEL_EXPORT]() {},
        [KM_TAB_ACTIVE](state, isActive) {
            state.kmTabActive = isActive;
        },
    },
};

export default kaplanMeierModule;
